import { IBase } from '../shared/IBase';
import { IUser } from '../user/IUser';
import { Offer } from './Offer';

export interface OfferPdf extends IBase {
    name: string;
    mime: string;
    originalName: string;
    path: string;
    offer: Offer;
    sentBy: IUser;
    type: OfferPdfTypeEnum;
}

export enum OfferPdfTypeEnum {
    BRAND = 'brand',
    INFLUENCER = 'influencer',
}

export interface OfferPdfOfferAutocomplete {
    id: number;
    campaignId?: number;
    campaignTitle?: string;
    userId?: number;
    userDisplayName?: string;
}

export interface OfferPdfCampaignAutocomplete {
    id: number;
    title: string;
}

export interface OfferPdfUserAutocomplete {
    id: number;
    displayName?: string;
    firstName?: string;
    lastName?: string;
}
